var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class Store {
  constructor(initialState) {
    __publicField(this, "state");
    __publicField(this, "listeners", /* @__PURE__ */ new Set());
    __publicField(this, "getSnapshot", () => {
      return this.state;
    });
    __publicField(this, "setState", (newState) => {
      const nextState = typeof newState === "function" ? newState(this.state) : newState;
      this.state = { ...this.state, ...nextState };
      this.emitChange();
    });
    __publicField(this, "subscribe", (listener) => {
      this.listeners.add(listener);
      return () => {
        this.listeners.delete(listener);
      };
    });
    this.state = initialState;
  }
  emitChange() {
    for (const listener of this.listeners) {
      listener();
    }
  }
}
const createStore = (initialState) => new Store(initialState);
export {
  createStore
};
